import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=870b8b50&"
import script from "./Publish.vue?vue&type=script&lang=js&"
export * from "./Publish.vue?vue&type=script&lang=js&"
import style0 from "./Publish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('870b8b50')) {
      api.createRecord('870b8b50', component.options)
    } else {
      api.reload('870b8b50', component.options)
    }
    module.hot.accept("./Publish.vue?vue&type=template&id=870b8b50&", function () {
      api.rerender('870b8b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/Publish.vue"
export default component.exports